import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

import * as moment from 'moment';

import * as _ from 'lodash';

moment.locale('es');

export interface CalendarDate {
  blocked?: boolean;
  mDate: moment.Moment;
  selected?: boolean;
  today?: boolean;
  warning?: boolean;
}

@Component({
  selector: 'calendar-widget',
  standalone: false,
  templateUrl: 'calendar-widget.component.html',
  styleUrls: [`calendar-widget.component.scss`]
})

export class CalendarWidgetComponent implements OnInit, OnChanges {

  currentDate = moment();
  dayNames = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];
  weeks: CalendarDate[][] = [];
  sortedDates: CalendarDate[] = [];

  @Input() selectedDate: CalendarDate;
  @Input() selectedDates: CalendarDate[] = [];
  @Input() warningDates: moment.Moment[] = [];
  @Input() blockedDates?: moment.Moment [] = [];
  @Output() onSelectDate = new EventEmitter<CalendarDate>();

  @Input() initialCalendarDate?: moment.Moment;
  @Input() endCalendarDate?: moment.Moment;


  constructor() {
  }

  ngOnInit() {
    if (this.selectedDate) {
      this.currentDate = moment(this.selectedDate.mDate);
    }
    this.generateCalendar();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedDates &&
      changes.selectedDates.currentValue &&
      changes.selectedDates.currentValue.length > 1) {
      // sort on date changes for better performance when range checking
      this.sortedDates = _.sortBy(changes.selectedDates.currentValue, (m: CalendarDate) => m.mDate.valueOf());
      this.generateCalendar();
    }
  }

  generateCalendar(): void {
    const dates = this.fillDates(this.currentDate);
    const weeks: CalendarDate[][] = [];
    while (dates.length > 0) {
      weeks.push(dates.splice(0, 7));
    }

    this.weeks = weeks;
  }

  fillDates(currentMoment: moment.Moment): CalendarDate[] {
    const firstOfMonth = moment(currentMoment).startOf('month').day();
    const firstDayOfGrid = moment(currentMoment).startOf('month').subtract(firstOfMonth, 'days');
    const start = firstDayOfGrid.date();
    return _.range(start, start + 42)
      .map((date: number): CalendarDate => {
        const d = moment(firstDayOfGrid).date(date);
        const warning = this.warningDates.filter(mDate => {
          return mDate.isSame(d);
        });
        const blocked = this.blockedDates.filter(mDate => {
          return mDate.isSame(d);
        });
        return {
          blocked: blocked.length > 0,
          mDate: d,
          selected: this.isSelected(d),
          today: this.isToday(d),
          warning: warning.length > 0
        };
      });
  }

  prevMonth() {
    this.currentDate = moment(this.currentDate).subtract(1, 'months');
    this.generateCalendar();
  }

  prevMonthStatus() {
    const currMonth = this.currentDate.get('month'),
      initialMonth = this.initialCalendarDate.get('month'),
      currYear = this.currentDate.get('year'),
      initialYear = this.initialCalendarDate.get('year');
    return moment([currYear, currMonth]).isSame(moment([initialYear, initialMonth]));
  }

  nextMonth() {
    this.currentDate = moment(this.currentDate).add(1, 'months');
    this.generateCalendar();
  }

  nextMonthStatus() {
    const currMonth = this.currentDate.get('month'),
      endMonth = this.endCalendarDate.get('month'),
      currYear = this.currentDate.get('year'),
      endYear = this.endCalendarDate.get('year');
    return moment([currYear, currMonth]).isSame(moment([endYear, endMonth]));
  }

  firstMonth(): void {
    this.currentDate = moment(this.currentDate).startOf('year');
    this.generateCalendar();
  }

  lastMonth(): void {
    this.currentDate = moment(this.currentDate).endOf('year');
    this.generateCalendar();
  }

  // prevYear(): void {
  //     this.currentDate = moment(this.currentDate).subtract(1, 'year');
  //     this.generateCalendar();
  // }
  //
  // nextYear(): void {
  //     this.currentDate = moment(this.currentDate).add(1, 'year');
  //     this.generateCalendar();
  // }

  // date checkers

  isToday(date: moment.Moment): boolean {
    return moment().isSame(moment(date), 'day');
  }

  isSelected(date: moment.Moment): boolean {
    return _.findIndex(this.selectedDates, (selectedDate) => {
      return moment(date).isSame(selectedDate.mDate, 'day');
    }) > -1;
  }

  isSelectedMonth(date: moment.Moment): boolean {
    return moment(date).isSame(this.currentDate, 'month');
  }

  selectDate(date: CalendarDate): void {
    this.onSelectDate.emit(date);
  }
}
